import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { get } from './container';
import initTranslations from './translations';
import App from './modules/common/containers/App';
import './assets/styles/css/index.css';

initTranslations();

ReactDOM.render(
  <Provider store={get('store')}>
    <App />
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js